import { SetStateAction, useEffect, useState, useRef } from 'react';
import defaultAvatar from "../assets/Avatar.png";
import { getUserPhoto, getUsersData } from '../utils/peopleSearch';
import { User, Presence, UserStatus, Conversation, Participant, useChat, ConversationRole, TypingUsersList } from '../@chatscope/use-chat/src';
import { useMsal } from "@azure/msal-react";
import { Search, Avatar } from "@chatscope/chat-ui-kit-react";
import Button from '@mui/material/Button';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

export const SearchBar = (conversationId: any) => {
    const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
    const { instance } = useMsal();
    const [searchValue, setSearchValue] = useState("");
    const [searchResults, setSearchResults] = useState<User[]>([]);
    const [selectedUsers, setSelectedUsers] = useState<User[]>([]);

    const searchValueRef = useRef<string>("");

    // Get all chat related values and methods from useChat hook 
    const {
        setActiveConversation, getCurrentUser, addConversation, addUser, activeConversation
    } = useChat();

    useEffect(() => {
        searchValueRef.current = searchValue;
    }, [searchValue]);

    const fetchData = async (value: any) => {
        try {
            let results: any;

            results = await getUsersData(instance, value);

            if (Array.isArray(results) && results.length > 0) {
                const tempPeople: User[] = [];
                for (const person of results) {
                    let userObj = new User({
                        id: person.userPrincipalName.substring(0, 6),
                        presence: new Presence({ status: UserStatus.Unknown, description: "" }),
                        firstName: person.givenName,
                        lastName: person.surname,
                        username: person.displayName,
                        upn: person.userPrincipalName,
                        avatar: defaultAvatar,
                        bio: ""
                    })
                    tempPeople.push(userObj);
                    console.log("User: " + person.displayName + " added to search results.");
                    getUserPhoto(instance, person.userPrincipalName).then(photo => {
                        userObj.avatar = photo;
                        console.log("User Photo for: " + person.displayName);
                        if (searchValueRef.current.length > 2) {
                            setSearchResults([...tempPeople]);
                        }
                    });
                }
                return tempPeople;
            }
            else {
                return ([]);
            }
        } catch (error) {
            console.log("[fetchData] Error: " + error);
            return ([]);
        }
    }

    const addUserToExistingConversation = (selectedUsers: User[]) => {
        for (const userInfo of selectedUsers) {
            activeConversation?.participants.push(
                new Participant({
                    id: userInfo.id,
                    upn: userInfo.upn
                })
            );
            addUser(userInfo);
        }
        setSelectedUsers([]);
    }

    const updateList = async (value: any) => {
        if (value) {
            const peopleArray = await fetchData(value);
            const searchCheck = searchValueRef.current;
            if (value.length > 2 && searchCheck.length > 2) {
                setSearchResults(peopleArray);
            }
            else {
                setSearchResults([]);
            }
        }
    }

    const handleSearch = (value: SetStateAction<string>) => {
        if (value.length < 3) {
            setSearchResults([]);
        } else if (value.length > 2) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            const newTimeoutId = setTimeout(() => {
                updateList(value);
            }, 200);
            setTimeoutId(newTimeoutId);
        }
    }

    const handleBlur = () => {
        setTimeout(() => {
            setSearchValue('');
            setSearchResults([]);
        }, 200);
    }

    const handleUserSelect = (person: User) => {
        setSearchResults([]);
        setSelectedUsers(prevUsers => [...prevUsers, person]);
        console.log(conversationId);
    }

    const cancelConversation = () => {
        setSelectedUsers([]);
    }

    function createConversation(userId: string, upn: string): Conversation {
        return new Conversation({
            id: "",
            participants: [
                new Participant({
                    id: userId,
                    role: new ConversationRole([]),
                    upn: upn
                })
            ],
            unreadCounter: 0,
            typingUsers: new TypingUsersList({ items: [] }),
            draft: ""
        });
    }

    const startConversation = async (selectedUsers: User[]) => {
        const currentUser: User<any> | undefined = getCurrentUser();
        let newConversation: Conversation;

        if (currentUser) {
            newConversation = createConversation(currentUser.id, currentUser.upn);
            selectedUsers.forEach((user: User) => {
                newConversation.participants.push(new Participant({
                    id: user.id,
                    role: new ConversationRole([]),
                    upn: user.upn
                }));
                addUser(user);
            });
    
            addUser(currentUser as User<any>);
    
            console.log("Conversation: " + newConversation.id);
            addConversation(newConversation);
    
            setActiveConversation(newConversation.id);
            setSelectedUsers([]);
        } 
    }

    return (
        <div style={{ margin: 0, overflowY: 'auto' }}>
            <Search
                placeholder="Search..."
                value={searchValue}
                onChange={(e) => {
                    setSearchValue(e);
                    handleSearch(e);
                }}
                onClearClick={() => {
                    setSearchValue("")
                    setSearchResults([])
                }}
                onBlur={() => { handleBlur() }}
            />
            <div style={{ position: 'relative', margin: 0 }}>
                <div className="search-list" style={{ display: 'flex', zIndex: 10, margin: 0 }}>
                    {
                        searchResults.map((personResult: User) => {
                            return (
                                <div
                                    key={personResult.id}
                                    className="search-results"
                                    id="searchName"
                                    style={{ display: "flex", alignItems: "center", marginRight: "8px", margin: 0 }}
                                    onClick={(e) => {
                                        var upn = personResult.upn;
                                        console.log("Selected User: " + upn);
                                        handleUserSelect(personResult);
                                    }}
                                >
                                    <Avatar src={personResult.avatar} size="sm" name={personResult.username} />
                                    <span style={{ marginLeft: "8px" }} className="search-name">{personResult.username}</span>
                                </div>
                            );
                        })
                    }
                </div>
                {selectedUsers.length > 0 && (
                    <div className="search-list" style={{ display: 'flex', zIndex: 2, marginTop: "5px" }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            marginRight: "8px",
                            margin: 0,
                            position: "relative"
                        }}>
                            <span style={{ marginLeft: "8px" }} className="search-name">Selected:</span>
                            <CancelOutlinedIcon
                                fontSize = "small" 
                                sx={{
                                    color: "#1976d2",
                                    position: "absolute",
                                    top: 2,
                                    right: 2,
                                    cursor: 'pointer'
                                }}
                                onClick={() => cancelConversation()}
                            />
                        </div>
                        {
                            selectedUsers.map((personResult: User) => {
                                return (
                                    <div
                                        key={personResult.id}
                                        style={{ display: "flex", alignItems: "center", margin: '4px 0 4px 8px' }}
                                    >
                                        <Avatar src={personResult.avatar} size="sm" name={personResult.username} />
                                        <span style={{ marginLeft: "8px" }} className="search-name">{personResult.username}</span>
                                    </div>
                                );
                            })
                        }
                        {!conversationId || Object.keys(conversationId).length === 0 ? (
                            <div style={{ display: 'flex', justifyContent: 'flex-end'  }}>
                                <Button size="small" variant="contained" onClick={() => startConversation(selectedUsers)}>Start Conversation</Button>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button size="small" variant="contained" onClick={() => addUserToExistingConversation(selectedUsers)}>Add</Button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}